import React from 'react'
import LeftImageContainer from 'Common/LeftImageContainer';
import Grid from '@mui/material/Grid';
import styles from './index.module.scss'
import ChangePasswordImg from 'Assets/Images/changepassword.png'
import ChangePasswordForm from 'Components/ChangePassword'

const ChangePassword = () => {
    return (
        <Grid container>
            <Grid item xs={12} md={7}>
                <LeftImageContainer heading='CHANGE PASSWORD' Image={ChangePasswordImg} />
            </Grid>

            <Grid item xs={12} md={5} className={styles.container}>
                <ChangePasswordForm />
            </Grid>
        </Grid >
    );
}

export default ChangePassword;